<template>
    <h2>404</h2>
    <h3>Page Not Found</h3>
</template>